/* ═══════════════════════════════════════════════════════════════════════════
   ECLO — BANNIÈRE COOKIEBOT v4 : voile, verrou de scroll, Échap
   ---------------------------------------------------------------------------
   Fichier : assets/eclo-cookiebot.js
   Appelé depuis layout/theme.liquid par :
     <script src="{{ 'eclo-cookiebot.js' | asset_url }}" defer></script>

   TROIS RESPONSABILITÉS, PAS UNE DE PLUS :
     1. créer le voile derrière le dialogue — la configuration « Pop up »
        de Cookiebot n'en fournit pas ;
     2. verrouiller le défilement de la page pendant l'affichage ;
     3. empêcher Échap de fermer sans réponse.

   Ce script ne décide JAMAIS de l'affichage : c'est Cookiebot qui ouvre et
   qui ferme. S'il ne se charge pas, on perd le voile et le verrou, mais la
   bannière reste parfaitement utilisable. La dégradation est gracieuse.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var ID_VOILE = "eclo-cookie-voile";
  var ACTIVE = "CybotCookiebotDialogActive";

  var positionMemorisee = 0;
  var verrouille = false;
  var attente = null;

  function dialogue() {
    return document.getElementById("CybotCookiebotDialog");
  }

  /* Ouvert = classe d'état présente ET display non nul. Les deux conditions
     sont nécessaires : Cookiebot ferme tantôt par style inline, tantôt par
     retrait de la classe. */
  function estOuvert() {
    var d = dialogue();
    if (!d || !d.classList.contains(ACTIVE)) return false;
    return window.getComputedStyle(d).display !== "none";
  }

  function voile() {
    var v = document.getElementById(ID_VOILE);
    if (v) return v;
    v = document.createElement("div");
    v.id = ID_VOILE;
    v.setAttribute("aria-hidden", "true");
    document.body.appendChild(v);
    return v;
  }

  /* Juste EN DESSOUS du dialogue, jamais au-dessus : au-dessus, le voile
     intercepterait les clics sur les boutons. */
  function zIndexVoile() {
    var d = dialogue();
    var z = d ? parseInt(window.getComputedStyle(d).zIndex, 10) : NaN;
    return isNaN(z) ? 2147483630 : z - 1;
  }

  /* position:fixed sur body plutôt que overflow:hidden : c'est la seule
     technique qui tienne sur iOS. La position est mémorisée puis restaurée
     exactement. */
  function verrouiller() {
    if (verrouille) return;
    positionMemorisee = window.pageYOffset || document.documentElement.scrollTop || 0;
    var s = document.body.style;
    s.position = "fixed";
    s.top = -positionMemorisee + "px";
    s.left = "0";
    s.right = "0";
    s.width = "100%";
    verrouille = true;
  }

  function deverrouiller() {
    if (!verrouille) return;
    var s = document.body.style;
    s.position = "";
    s.top = "";
    s.left = "";
    s.right = "";
    s.width = "";
    window.scrollTo(0, positionMemorisee);
    verrouille = false;
  }

  function synchroniser() {
    var ouvert = estOuvert();
    var v = document.getElementById(ID_VOILE);

    if (ouvert) {
      v = voile();
      v.style.zIndex = String(zIndexVoile());
      v.setAttribute("data-on", "true");
      verrouiller();
    } else {
      if (v) v.setAttribute("data-on", "false");
      deverrouiller();
    }
  }

  /* Les mutations arrivent par paquets : on ne synchronise qu'une fois par
     image, sinon le verrou se pose et se retire en boucle. */
  function planifier() {
    if (attente) return;
    attente = window.requestAnimationFrame(function () {
      attente = null;
      synchroniser();
    });
  }

  /* Échap ne doit pas valider ni fermer sans réponse. En phase de capture
     pour passer avant les écouteurs de Cookiebot. */
  document.addEventListener("keydown", function (e) {
    if ((e.key === "Escape" || e.keyCode === 27) && estOuvert()) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  /* Le dialogue peut être injecté tardivement — jusqu'à plusieurs secondes
     quand Cookiebot passe par GTM. On surveille donc le document entier
     jusqu'à le trouver, puis on observe le dialogue lui-même. */
  var suivi = false;
  function observerLeDialogue() {
    var d = dialogue();
    if (!d || suivi) return;
    suivi = true;
    new MutationObserver(planifier).observe(d, {
      attributes: true,
      attributeFilter: ["class", "style"]
    });
  }

  function demarrer() {
    observerLeDialogue();
    new MutationObserver(function () {
      observerLeDialogue();
      planifier();
    }).observe(document.documentElement, { childList: true, subtree: true });
    synchroniser();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", demarrer);
  } else {
    demarrer();
  }

  /* Raccourci : l'observateur suffit, ces évènements ne font qu'accélérer
     la réaction. */
  ["CookiebotOnDialogInit", "CookiebotOnDialogDisplay",
   "CookiebotOnAccept", "CookiebotOnDecline"].forEach(function (nom) {
    window.addEventListener(nom, planifier);
  });
}());
